import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalInvoiceCreateProps {}

const ModalInvoiceCreate = ({}: ModalInvoiceCreateProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.createInvoice');
  const onClose = () => {
    closeSingleModal('createInvoice');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Nova invoice"
      height={'auto'}
      width={'60vw'}
      backgroundColor={'#ececec'}
    >
      <Form.Export.Invoice.Create />
    </Modal>
  );
};

export default ModalInvoiceCreate;
